// extracted by mini-css-extract-plugin
export var externalLink = "_am-0";
export var internalLinkLabel = "_am-1";